import React from 'react';
import { IconProps } from './model/IconInterface';

const SproutIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <path d='M12 21V11' />
        <path d='M12 11c0-3-3-5-6-5 0 3 3 5 6 5z' />
        <path d='M12 11c0-3 3-5 6-5 0 3-3 5-6 5z' />
        <path d='M5 21h14' />
    </svg>
);

export default SproutIcon;
